<template>
    <span>
    <ps-icon v-for="action in actionList" :icon="action.icon" :title="action.title" additionalClasses="icon-table" :click="action.click" :key="action.icon" />
  </span>
</template>

<script>
import PsIcon from './ps-icon';
export default {
    name: "PsActions",
    props: {
        actionList: {
            type: Array,
            required: true,
            default: [ {icon: 'copy', click: 'copyRow'}]
        }
    },
    mounted()  {
   
        if (typeof(this.$parent) !== 'undefined' && typeof(this.$parent.$vnode) != 'undefined'){
            if(this.$parent.$vnode.tag.indexOf("PsColumn") >= 0)
            {
                this.$el.remove();
            }
        }
    }
};
</script>
<style>
@import "../styles/ps-icon.css";
</style>
